import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgVictriaMetrics = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-victria-metrics';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M10.22 3.721c-2.602.232-4.293.677-6.932 1.823l-.452.196.093.08c.051.044 2.079 1.617 4.508 3.496 4.1 3.173 4.421 3.412 4.499 3.364.192-.12 9.264-6.929 9.263-6.954 0-.014-.365-.167-.81-.34-2.345-.911-4.089-1.346-6.449-1.609-.661-.073-3.111-.11-3.72-.056m3.22 1.52c1.009.087 2.009.239 2.92.444.563.127 1.61.414 1.706.468.039.022-.879.731-3.032 2.343a306 306 0 0 1-3.131 2.328c-.033.013-5.847-4.441-6.043-4.629-.059-.057.018-.092.577-.256a18.2 18.2 0 0 1 4.223-.737c.72-.041 2.087-.021 2.78.039M3 9.327c-.231.311-.425.577-.431.592-.012.03 9.377 7.101 9.431 7.101s9.443-7.071 9.431-7.101c-.044-.109-.86-1.155-.895-1.148-.025.005-1.946 1.44-4.27 3.189S12.022 15.14 12 15.14s-1.942-1.431-4.266-3.18-4.245-3.184-4.27-3.189-.233.245-.464.556m-.004 4.318c-.248.333-.432.614-.411.628s2.139 1.606 4.705 3.537 4.686 3.51 4.71 3.51 2.143-1.579 4.709-3.51l4.705-3.537c.022-.014-.16-.293-.41-.628l-.451-.602-3.146 2.366a2931 2931 0 0 0-4.277 3.22l-1.13.854-1.37-1.034c-.753-.569-2.678-2.018-4.277-3.22l-2.906-2.186z"
    })
  }));
});
export default SvgVictriaMetrics;